import { render } from "./ServiceFormComponent.vue?vue&type=template&id=5ada6872&scoped=true"
import script from "./ServiceFormComponent.vue?vue&type=script&lang=js"
export * from "./ServiceFormComponent.vue?vue&type=script&lang=js"

import "./ServiceFormComponent.vue?vue&type=style&index=0&id=5ada6872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ada6872"]])

export default __exports__